export const QUESTION_TYPE_MEAL = 'Meal';
export const GOOGLE_API_KEY = process.env.REACT_APP_GLM_GOOGLE_API_KEY;
